(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanyInvoiceInfoSearch', CompanyInvoiceInfoSearch);

    CompanyInvoiceInfoSearch.$inject = ['$resource'];

    function CompanyInvoiceInfoSearch($resource) {
        var resourceUrl = 'api/_search/company-invoice-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
